import PuzzleVerification from './puzzleVerification.vue'

PuzzleVerification.install = function(Vue) {
  Vue.component(PuzzleVerification.name, PuzzleVerification);
};

export default PuzzleVerification;


// WEBPACK FOOTER //
// ./src/index.js